import { useLocation } from 'react-router-dom';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function Bearworld() {
    const query = useQuery();
    const userId = query.get('userId');
    const username = query.get('username');
    return (<h1>{username}</h1>)
}

export default Bearworld;